import { render, staticRenderFns } from "./TransactionBulksList.vue?vue&type=template&id=56831151&"
import script from "./TransactionBulksList.vue?vue&type=script&lang=js&"
export * from "./TransactionBulksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports